import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { logout } from "../api/auth";
import AsyncButton from "./AsyncButton";

const links = {
  platform_admin: [
    ["/platform/registrations", "Registrations"],
    ["/platform/support", "Customer support"],
    ["/admin/audit", "Audit trail"],
  ],
  facility_admin: [
    ["/admin", "Review queue"],
    ["/admin/inmates", "Inmates"],
    ["/admin/attorney-access", "Attorney access"],
    ["/admin/inmate-access", "Client access"],
    ["/admin/settings", "Settings"],
    ["/admin/audit", "Audit trail"],
  ],
  attorney: [
    ["/attorney/documents", "Sent documents"],
    ["/attorney/inbox", "Inbox"],
    ["/attorney/upload", "Upload"],
    ["/attorney/access", "Facility access"],
    ["/attorney/inmate-access", "Client access"],
  ],
  inmate: [
    ["/inmate/documents", "My documents"],
    ["/inmate/upload", "Send document"],
  ],
};

Object.keys(links).forEach((role) => links[role].push(['/app/academy', 'Academy']));
links.platform_admin.push(['/platform/demos', 'Demo Requests']);

export default function RoleNavigation({ role, demo = false }) {
  const [signingOut, setSigningOut] = useState(false);
  const navigate = useNavigate();
  const normalizedRole = role === "admin" ? "facility_admin" : role;

  async function signOut() {
    if (signingOut) return;
    setSigningOut(true);
    try {
      await logout();
    } finally {
      navigate("/login", { replace: true });
    }
  }

  return (
    <nav className="role-navigation" aria-label="Primary navigation">
      {(demo ? [["/app/demo", "Guided tour"], ["/app/academy", "Academy"]] : (links[normalizedRole] || [])).map(([to, label]) => (
        <NavLink key={to} to={to} className={({ isActive }) => `btn btn-sm ${isActive ? "btn-light" : "btn-outline-light"}`}>
          {label}
        </NavLink>
      ))}
      <AsyncButton
        type="button"
        className="btn btn-sm btn-outline-light"
        busy={signingOut}
        busyText="Signing out…"
        onClick={signOut}
      >
        Sign out
      </AsyncButton>
    </nav>
  );
}
